class IconBoxSection {
  static boot() {
    if (typeof Swiper === 'undefined') {
      window.setTimeout(() => IconBoxSection.boot(), 50);
      return;
    }
    IconBoxSection.initAll();
  }

  static initAll() {
    document.querySelectorAll('[data-icon-box-mobile]').forEach((root) => {
      IconBoxSection._whenNear(root, () => {
        if (root.iconBoxInstance) {
          root.iconBoxInstance.destroy();
        }
        root.iconBoxInstance = new IconBoxSection(root);
      });
    });
  }

  // Lazy-init: only build the carousel when the section nears the viewport, so
  // below-the-fold Swipers don't run on initial page load (cuts JS exec / TBT).
  // In the theme editor (designMode) init immediately for live preview.
  static _whenNear(el, cb) {
    if (window.Shopify && window.Shopify.designMode) { cb(); return; }
    if (el.dataset.lazyInitObserved === 'true') return;
    el.dataset.lazyInitObserved = 'true';
    if (!('IntersectionObserver' in window)) { cb(); return; }
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { obs.unobserve(entry.target); cb(); }
      });
    }, { rootMargin: '300px 0px' });
    io.observe(el);
  }

  constructor(root) {
    this.root = root;
    this.track = root.querySelector('.icon-box__track');
    this.readConfig();
    this.initSwiper();
  }

  readConfig() {
    const root = this.root;
    const slidesRaw = root.dataset.slidesPerView || root.dataset.mobileItems || '1';
    const parsed = parseFloat(slidesRaw, 10);
    this.mobileItems = Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
    
    const gapMobile = parseInt(root.dataset.gapMobile, 10);
    this.gapMobile = Number.isFinite(gapMobile) ? Math.max(0, gapMobile) : 0;
    
    this.mobileLayout = root.dataset.mobileLayout || 'grid';
    this.autoplay = root.dataset.autoplay === 'true';
    this.loop = root.dataset.loop === 'true';
    this.showBullets = root.dataset.showBullets === 'true';
    this.showArrows = root.dataset.showArrows === 'true';
  }

  getSlides() {
    if (!this.track) return [];
    return [...this.track.children].filter((el) => el.classList.contains('icon-box__item'));
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this.root.iconBoxInstance = null;
  }

  initSwiper() {
    // If layout isn't a carousel, don't build Swiper at all
    if (this.mobileLayout !== 'carousel' || !this.track) return;

    const slides = this.getSlides();
    if (slides.length < 1) return;

    // Prepare structural classes immediately without toggling them later
    this.root.classList.add('swiper', 'bls__swiper');
    this.track.classList.add('swiper-wrapper');
    slides.forEach((slide) => slide.classList.add('swiper-slide'));

    const paginationEl = this.root.querySelector('.swiper-pagination');
    const nextEl = this.root.querySelector('.swiper-button-next');
    const prevEl = this.root.querySelector('.swiper-button-prev');

    // Use Swiper's native breakpoints. 
    // It enables Swiper configurations below 992px, and disables it above.
    const swiperConfig = {
      breakpoints: {
        0: {
          enabled: true,
          slidesPerView: this.mobileItems,
          spaceBetween: this.gapMobile,
        },
        992: {
          enabled: false, // Automatically kills carousel behavior on desktop
        }
      },
      speed: 400,
      grabCursor: true,
      watchOverflow: true,
    };

    if (this.autoplay) {
      swiperConfig.autoplay = { delay: 3000, disableOnInteraction: false };
    }
    if (this.loop && slides.length > 1) {
      swiperConfig.loop = true;
    }
    if (this.showBullets && paginationEl) {
      swiperConfig.pagination = { el: paginationEl, clickable: true, type: 'bullets' };
    }
    if (this.showArrows && nextEl && prevEl) {
      swiperConfig.navigation = { nextEl, prevEl };
    }

    this.swiper = new Swiper(this.root, swiperConfig);
  }
}

IconBoxSection.boot();

function initIconBoxInSection(section) {
  if (!section) return;
  section.querySelectorAll('[data-icon-box-mobile]').forEach((root) => {
    if (root.iconBoxInstance) {
      root.iconBoxInstance.destroy();
    }
    root.iconBoxInstance = new IconBoxSection(root);
  });
}

document.addEventListener('shopify:section:load', (event) => initIconBoxInSection(event.target));
document.addEventListener('shopify:section:reorder', (event) => initIconBoxInSection(event.target));
document.addEventListener('shopify:block:select', (event) => initIconBoxInSection(event.target.closest('.shopify-section')));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-icon-box-mobile]').forEach((root) => {
    if (root.iconBoxInstance) root.iconBoxInstance.destroy();
  });
});